import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import FullSizeSkeleton from "../Skeleton/FullSizeSkeleton/FullSizeSkeleton";
import AspectRatio from "../../helpers/AspectRatio";
import "./Image.css";
var styles = { "image": "c63693", "imageWrapper": "fec837", "skeleton": "d3f72d" };
import { breakpointSizes, Breakpoints } from '../../utils/constants';
const Image = ({ src, altText, className, hasLazyLoad = true, intersectionVisibleOptions = { root: undefined, rootMargin: '200% 0px', threshold: 0 }, ratio = '2:3', sources, testId, }) => {
    const [imageSrc, setImageSrc] = useState(!hasLazyLoad ? src : '');
    const [isLoaded, setIsLoaded] = useState(false);
    const imageWrapperRef = useRef(null);
    const mediaToString = ({ type, breakpoint }) => {
        return `(${type === 'minWidth' ? 'min' : 'max'}-width:${breakpointSizes[Breakpoints[breakpoint]]}px)`;
    };
    const sourceElements = sources &&
        sources.map((source) => (React.createElement("source", { key: source.srcset, media: mediaToString(source.media), srcSet: source.srcset })));
    const handleImageLoad = () => {
        setIsLoaded(true);
    };
    useEffect(() => {
        setIsLoaded(false);
        const observer = new IntersectionObserver(([observerEntry]) => {
            if (observerEntry.isIntersecting) {
                setImageSrc(src);
            }
        }, intersectionVisibleOptions);
        const reference = imageWrapperRef.current;
        if (reference)
            observer.observe(reference);
        return () => {
            if (reference) {
                observer.unobserve(reference);
            }
        };
    }, [src, intersectionVisibleOptions]);
    return (React.createElement(AspectRatio, { ratio: ratio, testId: testId },
        !isLoaded && React.createElement(FullSizeSkeleton, { className: styles.skeleton }),
        React.createElement("picture", { ref: imageWrapperRef, className: cn(className, styles.imageWrapper) },
            sourceElements,
            React.createElement("img", { src: imageSrc, alt: altText, className: styles.image, onLoad: handleImageLoad }))));
};
export default Image;
//# sourceMappingURL=Image.js.map